/* tslint:disable */
/* eslint-disable */
/**
 * Client dashboard
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AverageDaysWorkedPerFreelancerFamilyResponse } from './';
import {
    AverageDaysWorkedPerFreelancerFamilyResponseFromJSON,
    AverageDaysWorkedPerFreelancerFamilyResponseFromJSONTyped,
    AverageDaysWorkedPerFreelancerFamilyResponseToJSON,
} from './';
import type { ClientCompanyGsvResponse } from './';
import {
    ClientCompanyGsvResponseFromJSON,
    ClientCompanyGsvResponseFromJSONTyped,
    ClientCompanyGsvResponseToJSON,
} from './';
import type { FreelancerPerCategoryResponse } from './';
import {
    FreelancerPerCategoryResponseFromJSON,
    FreelancerPerCategoryResponseFromJSONTyped,
    FreelancerPerCategoryResponseToJSON,
} from './';
import type { FreelancerPerFamilyResponse } from './';
import {
    FreelancerPerFamilyResponseFromJSON,
    FreelancerPerFamilyResponseFromJSONTyped,
    FreelancerPerFamilyResponseToJSON,
} from './';
import type { InvoicePerMonthResponse } from './';
import {
    InvoicePerMonthResponseFromJSON,
    InvoicePerMonthResponseFromJSONTyped,
    InvoicePerMonthResponseToJSON,
} from './';
import type { OpportunitiesPerFreelancerFamilyResponse } from './';
import {
    OpportunitiesPerFreelancerFamilyResponseFromJSON,
    OpportunitiesPerFreelancerFamilyResponseFromJSONTyped,
    OpportunitiesPerFreelancerFamilyResponseToJSON,
} from './';
import type { ProjectGsvPerMonthPerCategoryResponse } from './';
import {
    ProjectGsvPerMonthPerCategoryResponseFromJSON,
    ProjectGsvPerMonthPerCategoryResponseFromJSONTyped,
    ProjectGsvPerMonthPerCategoryResponseToJSON,
} from './';
import type { ProjectGsvPerMonthPerFamilyResponse } from './';
import {
    ProjectGsvPerMonthPerFamilyResponseFromJSON,
    ProjectGsvPerMonthPerFamilyResponseFromJSONTyped,
    ProjectGsvPerMonthPerFamilyResponseToJSON,
} from './';
import type { ProjectGsvPerMonthPerVerticalResponse } from './';
import {
    ProjectGsvPerMonthPerVerticalResponseFromJSON,
    ProjectGsvPerMonthPerVerticalResponseFromJSONTyped,
    ProjectGsvPerMonthPerVerticalResponseToJSON,
} from './';
import type { ProjectIndicatorResponse } from './';
import {
    ProjectIndicatorResponseFromJSON,
    ProjectIndicatorResponseFromJSONTyped,
    ProjectIndicatorResponseToJSON,
} from './';
import type { ProjectPerRatingResponse } from './';
import {
    ProjectPerRatingResponseFromJSON,
    ProjectPerRatingResponseFromJSONTyped,
    ProjectPerRatingResponseToJSON,
} from './';
import type { ProjectPerTypePerMonthResponse } from './';
import {
    ProjectPerTypePerMonthResponseFromJSON,
    ProjectPerTypePerMonthResponseFromJSONTyped,
    ProjectPerTypePerMonthResponseToJSON,
} from './';

/**
 * 
 * @export
 * @interface ProjectAnalyticsResponse
 */
export interface ProjectAnalyticsResponse {
    /**
     * 
     * @type {ProjectIndicatorResponse}
     * @memberof ProjectAnalyticsResponse
     */
    indicators: ProjectIndicatorResponse;
    /**
     * 
     * @type {Array<ProjectGsvPerMonthPerFamilyResponse>}
     * @memberof ProjectAnalyticsResponse
     */
    totalGsvSpentPerMonthPerFamily: Array<ProjectGsvPerMonthPerFamilyResponse>;
    /**
     * 
     * @type {Array<ProjectGsvPerMonthPerCategoryResponse>}
     * @memberof ProjectAnalyticsResponse
     */
    totalGsvSpentPerMonthPerCategory: Array<ProjectGsvPerMonthPerCategoryResponse>;
    /**
     * 
     * @type {Array<ProjectGsvPerMonthPerVerticalResponse>}
     * @memberof ProjectAnalyticsResponse
     */
    totalGsvSpentPerMonthPerVertical: Array<ProjectGsvPerMonthPerVerticalResponse>;
    /**
     * 
     * @type {Array<ClientCompanyGsvResponse>}
     * @memberof ProjectAnalyticsResponse
     */
    topClientCompaniesGsvSpent: Array<ClientCompanyGsvResponse>;
    /**
     * 
     * @type {Array<ClientCompanyGsvResponse>}
     * @memberof ProjectAnalyticsResponse
     */
    topClientCompaniesClientNameGsvSpent: Array<ClientCompanyGsvResponse>;
    /**
     * 
     * @type {Array<FreelancerPerCategoryResponse>}
     * @memberof ProjectAnalyticsResponse
     */
    freelancersPerCategory: Array<FreelancerPerCategoryResponse>;
    /**
     * 
     * @type {Array<FreelancerPerFamilyResponse>}
     * @memberof ProjectAnalyticsResponse
     */
    freelancersPerFamily: Array<FreelancerPerFamilyResponse>;
    /**
     * 
     * @type {Array<ProjectPerRatingResponse>}
     * @memberof ProjectAnalyticsResponse
     */
    projectPerRating: Array<ProjectPerRatingResponse>;
    /**
     * 
     * @type {Array<AverageDaysWorkedPerFreelancerFamilyResponse>}
     * @memberof ProjectAnalyticsResponse
     */
    averageDaysWorkedPerFamily: Array<AverageDaysWorkedPerFreelancerFamilyResponse>;
    /**
     * 
     * @type {Array<ProjectPerTypePerMonthResponse>}
     * @memberof ProjectAnalyticsResponse
     */
    projectPerTypePerMonth: Array<ProjectPerTypePerMonthResponse>;
    /**
     * 
     * @type {Array<InvoicePerMonthResponse>}
     * @memberof ProjectAnalyticsResponse
     */
    invoicePerMonth: Array<InvoicePerMonthResponse>;
    /**
     * 
     * @type {Array<OpportunitiesPerFreelancerFamilyResponse>}
     * @memberof ProjectAnalyticsResponse
     */
    opportunitiesPerFreelancerFamily: Array<OpportunitiesPerFreelancerFamilyResponse>;
}

/**
 * Check if a given object implements the ProjectAnalyticsResponse interface.
 */
export function instanceOfProjectAnalyticsResponse(value: object): value is ProjectAnalyticsResponse {
    if (!('indicators' in value) || value['indicators'] === undefined) return false;
    if (!('totalGsvSpentPerMonthPerFamily' in value) || value['totalGsvSpentPerMonthPerFamily'] === undefined) return false;
    if (!('totalGsvSpentPerMonthPerCategory' in value) || value['totalGsvSpentPerMonthPerCategory'] === undefined) return false;
    if (!('totalGsvSpentPerMonthPerVertical' in value) || value['totalGsvSpentPerMonthPerVertical'] === undefined) return false;
    if (!('topClientCompaniesGsvSpent' in value) || value['topClientCompaniesGsvSpent'] === undefined) return false;
    if (!('topClientCompaniesClientNameGsvSpent' in value) || value['topClientCompaniesClientNameGsvSpent'] === undefined) return false;
    if (!('freelancersPerCategory' in value) || value['freelancersPerCategory'] === undefined) return false;
    if (!('freelancersPerFamily' in value) || value['freelancersPerFamily'] === undefined) return false;
    if (!('projectPerRating' in value) || value['projectPerRating'] === undefined) return false;
    if (!('averageDaysWorkedPerFamily' in value) || value['averageDaysWorkedPerFamily'] === undefined) return false;
    if (!('projectPerTypePerMonth' in value) || value['projectPerTypePerMonth'] === undefined) return false;
    if (!('invoicePerMonth' in value) || value['invoicePerMonth'] === undefined) return false;
    if (!('opportunitiesPerFreelancerFamily' in value) || value['opportunitiesPerFreelancerFamily'] === undefined) return false;
    return true;
}

export function ProjectAnalyticsResponseFromJSON(json: any): ProjectAnalyticsResponse {
    return ProjectAnalyticsResponseFromJSONTyped(json, false);
}

export function ProjectAnalyticsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProjectAnalyticsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'indicators': ProjectIndicatorResponseFromJSON(json['indicators']),
        'totalGsvSpentPerMonthPerFamily': ((json['totalGsvSpentPerMonthPerFamily'] as Array<any>).map(ProjectGsvPerMonthPerFamilyResponseFromJSON)),
        'totalGsvSpentPerMonthPerCategory': ((json['totalGsvSpentPerMonthPerCategory'] as Array<any>).map(ProjectGsvPerMonthPerCategoryResponseFromJSON)),
        'totalGsvSpentPerMonthPerVertical': ((json['totalGsvSpentPerMonthPerVertical'] as Array<any>).map(ProjectGsvPerMonthPerVerticalResponseFromJSON)),
        'topClientCompaniesGsvSpent': ((json['topClientCompaniesGsvSpent'] as Array<any>).map(ClientCompanyGsvResponseFromJSON)),
        'topClientCompaniesClientNameGsvSpent': ((json['topClientCompaniesClientNameGsvSpent'] as Array<any>).map(ClientCompanyGsvResponseFromJSON)),
        'freelancersPerCategory': ((json['freelancersPerCategory'] as Array<any>).map(FreelancerPerCategoryResponseFromJSON)),
        'freelancersPerFamily': ((json['freelancersPerFamily'] as Array<any>).map(FreelancerPerFamilyResponseFromJSON)),
        'projectPerRating': ((json['projectPerRating'] as Array<any>).map(ProjectPerRatingResponseFromJSON)),
        'averageDaysWorkedPerFamily': ((json['averageDaysWorkedPerFamily'] as Array<any>).map(AverageDaysWorkedPerFreelancerFamilyResponseFromJSON)),
        'projectPerTypePerMonth': ((json['projectPerTypePerMonth'] as Array<any>).map(ProjectPerTypePerMonthResponseFromJSON)),
        'invoicePerMonth': ((json['invoicePerMonth'] as Array<any>).map(InvoicePerMonthResponseFromJSON)),
        'opportunitiesPerFreelancerFamily': ((json['opportunitiesPerFreelancerFamily'] as Array<any>).map(OpportunitiesPerFreelancerFamilyResponseFromJSON)),
    };
}

export function ProjectAnalyticsResponseToJSON(value?: ProjectAnalyticsResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'indicators': ProjectIndicatorResponseToJSON(value['indicators']),
        'totalGsvSpentPerMonthPerFamily': ((value['totalGsvSpentPerMonthPerFamily'] as Array<any>).map((v) => ProjectGsvPerMonthPerFamilyResponseToJSON(v))),
        'totalGsvSpentPerMonthPerCategory': ((value['totalGsvSpentPerMonthPerCategory'] as Array<any>).map((v) => ProjectGsvPerMonthPerCategoryResponseToJSON(v))),
        'totalGsvSpentPerMonthPerVertical': ((value['totalGsvSpentPerMonthPerVertical'] as Array<any>).map((v) => ProjectGsvPerMonthPerVerticalResponseToJSON(v))),
        'topClientCompaniesGsvSpent': ((value['topClientCompaniesGsvSpent'] as Array<any>).map((v) => ClientCompanyGsvResponseToJSON(v))),
        'topClientCompaniesClientNameGsvSpent': ((value['topClientCompaniesClientNameGsvSpent'] as Array<any>).map((v) => ClientCompanyGsvResponseToJSON(v))),
        'freelancersPerCategory': ((value['freelancersPerCategory'] as Array<any>).map((v) => FreelancerPerCategoryResponseToJSON(v))),
        'freelancersPerFamily': ((value['freelancersPerFamily'] as Array<any>).map((v) => FreelancerPerFamilyResponseToJSON(v))),
        'projectPerRating': ((value['projectPerRating'] as Array<any>).map((v) => ProjectPerRatingResponseToJSON(v))),
        'averageDaysWorkedPerFamily': ((value['averageDaysWorkedPerFamily'] as Array<any>).map((v) => AverageDaysWorkedPerFreelancerFamilyResponseToJSON(v))),
        'projectPerTypePerMonth': ((value['projectPerTypePerMonth'] as Array<any>).map((v) => ProjectPerTypePerMonthResponseToJSON(v))),
        'invoicePerMonth': ((value['invoicePerMonth'] as Array<any>).map((v) => InvoicePerMonthResponseToJSON(v))),
        'opportunitiesPerFreelancerFamily': ((value['opportunitiesPerFreelancerFamily'] as Array<any>).map((v) => OpportunitiesPerFreelancerFamilyResponseToJSON(v))),
    };
}

